import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var getColorById = function getColorById(theme, color) {
  var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var stringOpacity = opacity !== 100 ? opacity.toString() : null;
  return ['black', 'white'].includes(color) ? color : color.startsWith('plus.') ? "".concat(theme.plus[color.replace('plus.', '')]).concat(stringOpacity || '') : "".concat(theme.colors[color]).concat(stringOpacity || '');
};